import { GRAY_COLORS } from '../globalTheme';

export function getSelectSearchStyles() {
	return {
		selectSearchContainerCss: {
			position: 'relative' as const,
			display: 'flex',
			alignItems: 'center',
			padding: '10px 14px',
			height: '44px',
			borderRadius: 8,
			border: `1px solid ${GRAY_COLORS.gray300}`,
			marginTop: '8px'
		},
		inputLabel: {
			color: GRAY_COLORS.gray700
		}
	};
}
